import '../styles/reset.scss';
import '../styles/index.scss';

import $ from "expose-loader?exposes=$,jQuery!jquery";

import Scrollload from 'scrollload';
import 'scrollload/lib/traditionalSkin';

import "../scripts/gotop";

$("body").on("mouseenter", "#case-ls li", function() {
        
  var imgEle = $(this).find(".qr-box-wrapper").find("img.qrcode");
  var id = imgEle.attr('id');
  var that = this;
  var src = imgEle.attr("src");
  $(that).find(".qr-box-wrapper").fadeIn(400);

  if (!src) {
      $.ajax({
          url: `${process.env.HOST}/activity/getPreviewAppletQrCode`,  // 发送的路径
          type: "post",  // 发送方式
          dataType: 'JSON',  // 反序列化
          headers: {
              'Content-Type': 'application/json;charset=utf-8'
          },
          data:JSON.stringify({activityId: id}),  // 发送的数据
          success: (res) => {  // 成功获取到后端返回结果的回调函数
              imgEle.attr("src", 'data:image/png;base64,' + res.result.qrCode);
              imgEle.show();
          },
          error:()=>{  // 发送失败的回调函数
              console.log("二维码接口请求失败");
          }
      });
  }
      $(that).find(".qr-box-wrapper").fadeIn(400);

});
$("body").on("mouseleave", "#case-ls li", function() {
    $(this).find(".qr-box-wrapper").fadeOut(300);
});
$(".do-gotop").goTop();
$("#login").attr("href", process.env.Login);
window.pageNumber = 1;
window.pageSize = 20;
window.lastPage = 2;


// loadData(window.pageNumber, window.pageSize);

new Scrollload({
    // container 和 content 两个配置的默认取的scrollload-container和scrollload-content类的dom。只要你按照以上的dom结构写，这两个配置是可以省略的
    container: document.querySelector('.scrollload-container'),
  content: document.querySelector('.scrollload-content'),
  // 底部加载中的html
// 底部没有更多数据的html
  loadMore: function(sl) {
      
      if (window.lastPage === 1) {
        // 没有数据的时候需要调用noMoreData
          sl.noMoreData();
          return;
      }
      loadData(window.pageNumber, window.pageSize, sl);

      // 我这里用jquery的不是因为需要jquery，只是jquery的语法看起来比较简单。大家都认识。
      // 如果你不是用jquery，可以看看原生的insertAdjacentHTML方法来替代append
    //   $.ajax({
    //       type: 'GET',
    //       url: `http://rap.taobao.org/mockjsdata/14522/getgamelist?page=${page++}`,
    //       dataType: 'json',
    //       success: function(data){
    //           // contentDom其实就是你的scrollload-content类的dom
    //           $(sl.contentDom).append(data)

    //           // 处理完业务逻辑后必须要调用unlock
    //           sl.unLock()
    //       },
    //       error: function(xhr, type){
    //           // 加载出错，需要执行该方法。这样底部DOM会出现出现异常的样式。
    //           sl.throwException()
    //       }
    //   })
  }
});
// window.onscroll = debounce(scrollFn, 200);

// function debounce(fn, delay){
// 	let timeout;
// 	return function() {
// 		clearTimeout(timeout);
// 		timeout = setTimeout(()=>{
// 			fn.apply(this, arguments);
// 		},delay);
// 	};
// }
// function scrollFn(){
// 	//获取网页的总高度
// 	var htmlHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
// 	//clientHeight是网页在浏览器中的可视高度
// 	var clientHeight = document.body.clientHeight || document.documentElement.clientHeight;
// 	//scrollTop是浏览器滚动条的top位置
// 	var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
// 	//判断到底部了
// 	console.log(scrollTop + clientHeight  ,  htmlHeight);
// 	if (scrollTop + clientHeight > htmlHeight - 50) {
// 		loadData(window.pageNumber, window.pageSize);
// 	}
// }

function loadData(pageNumber, pageSize, sl) {
    $.ajax({
        url: process.env.HOST + "/official/listPageModuleInstance",
        type: "post",
        contentType: "application/json;charset=UTF-8",
        data: JSON.stringify({pageSize, pageNumber}),
        success: (res) => {
            console.log(res);
            const {list, lastPage} = res.result;
            let str = "";
            list.forEach(element => {
              str += `<li>
              <img src="${element.instancePic}" class="big-pic" alt="">
              <div class="qr-box-wrapper">
                <div class="qr-box">
                  <p>微信扫码，预览活动</p>
                  <img alt="" class="qrcode" id="${element.activityId}">
                  <img alt="" class="loading" src="https://dhd-online.oss-cn-shanghai.aliyuncs.com/adapay/saas/1/product/2022/12/28/c5dbb4c0-ffc6-4db0-877f-51dbe1af718e.gif">
                </div>
              </div>
            </li>`;
          });
            // $('#case-ls').append(str);
            window.pageNumber = window.pageNumber + 1;
            window.lastPage = +lastPage;
              // contentDom其实就是你的scrollload-content类的dom
              $(sl.contentDom).append(str);

              // 处理完业务逻辑后必须要调用unlock
              sl.unLock();
        },
        error:()=>{  // 发送失败的回调函数
            console.log("失败");
        }
    });
}
